<template>
    <div :class="{favoris:!isMobile,mfavoris:isMobile}">
        <p class="title">{{ langPage['l.general']['TXT_mesfavoris'] }}</p>
        <!-- <main>111111111111</main> -->

        <div class="tab">
            <router-link
                :class="item.path==$route.path || i==0&& $route.path=='/Favoris'?'active':''"
                v-for="(item,i) in routerlist"
                :key="i"
                :to="item.path"
            >{{ item.name }}
            </router-link>
        </div>

        <main>
            <!-- <div class="select">
              <span>32 articles</span>
              <div class="ml3" style="min-width:20px">Trier par/分类</div>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{condition}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="item.value" v-for="(item,index) in menuList" :key="index">{{item.value}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div> -->
            <router-view></router-view>
        </main>
    </div>
</template>
<script>
import topMenu from "../components/topMenu";

export default {
    name: "Favoris",
    components: {
        topMenu
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    },
    mounted() {
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            menuList: [{key: 1, value: '价格'}, {key: 2, value: '销量'}, {key: 3, value: '人气'},],
            condition: '',
            routerlist: [
                {
                    name: this.$store.state.langPage['compte-commandes-liste']['TXT_articles'],//产品
                    path: "/favoris/Articles"
                },
                {
                    name: this.$store.state.langPage['compte-popup-inscription']['TXT_vendeurs'],//品牌
                    path: "/favoris/Vendeurs"
                },
                {
                    name: this.$store.state.langPage['v4-lastthing']['TXT_historiquedenavigation'],//浏览历史记录
                    path: "/favoris/hstorique"
                }
            ]
        };
    },
    methods: {
        handleCommand(val) {
            this.condition = val
        }
    }
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Favoris.less">
</style>
